export const addressFieldProps = {
  address_line_1: '',
  address_line_2: '',
  address_city: '',
  address_region: '',
  address_country: '',
  address_postal_code: '',
}

export const addressInitialValues = (data) => {
  let addressValues = addressFieldProps

  if (data !== undefined) {
    addressValues.address_line_1 = data.address_line_1
    addressValues.address_line_2 = data.address_line_2
    addressValues.address_city = data.address_city
    addressValues.address_region = data.address_region
    addressValues.address_country = data.address_country
    addressValues.address_postal_code = data.addvress_postal_code
  }
  return addressValues
}
